import ProductImagePanel from './ProductImagePanel';
export default ProductImagePanel;
